import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MyHttpServer from './plugins/axios/index.js'
import moment from 'moment'; //日期格式化
import 'babel-polyfill';
import './libs/directives.js';//拖拽

import  KeepAliveManager from './plugins/KeepAliveManager.js';
import ElementUI from 'element-ui'
import { message} from './utils/resetMessage.js'
import MyFn from './plugins/function/common.js';

import VueBus from 'vue-bus';


/* 表格控件 */
import 'xe-utils'
import {VXETable} from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table/lib/index.css'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/font/iconfont.css'
import './assets/css/reset.css'
import './assets/stylus/base.styl'
import './assets/stylus/common.styl'
import './assets/stylus/reset-elementui.styl'
import './assets/stylus/window.styl'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(MyHttpServer);
Vue.use(MyFn);
Vue.use(VXETable);
Vue.use(VueBus);
Vue.use(KeepAliveManager);

VXETable.use(VXETablePluginElement);
Vue.prototype.$message = message;
Vue.prototype.$moment = moment;

Vue.mixin({
    beforeRouteLeave(to,from,next){
      let thiz=this;
      //判断是否为keepAlive下的组件
      if(thiz.$vnode.data.keepAlive){
          //thiz.$vnode.parent为keepAlive对象          
          this.$keepAliveManager.keepAlive=thiz.$vnode.parent;

          //是否清除路由源节点缓存
          if(from.meta&&from.meta.clearCache){            
            this.$keepAliveManager.clearCurrentVnodeCache(thiz.$vnode);
            from.meta.clearCache=false;//关闭清理
            from.meta.isOpened=false;
          }
      }
      next();      
    },    
    beforeRouteEnter(to,from,next){  
      next(vm => { 
        if(vm.$vnode.data.keepAlive){
          //vm.$vnode.parent为keepAlive对象          
          //vm.$keepAliveManager.keepAlive=vm.$vnode.parent;
          vm.$keepAliveManager.cacheKeepaliveSubNode(to.name,vm.$vnode)
        } 
      });      
    }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
